import { Typography, Box, styledComponent, Link } from '@hermes/web-components'

export const Specialties = styledComponent(Typography)(() => ({
  color: '#051851',
  fontSize: '12px',
  lineHeight: '18px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '200px',
  display: 'block'
}))

export const Container = styledComponent(Box)<{
  tabindex?: string
}>(() => ({
  padding: '24px',
  marginBottom: '24px',
  backgroundColor: '#FFF',
  borderRadius: '16px',
  border: '1px solid #D5DEF9',
  textAlign: 'start',
  width: '100%',
  height: '300px',
  outline: 'none'
}))

export const ReviewHeader = styledComponent(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  borderBottom: '1px solid #D5DEF9',
  paddingBottom: '16px',
  marginBottom: '16px',
  maxHeight: '57px'
}))

export const Verified = styledComponent(Typography)(() => ({
  color: '#2C3341',
  fontSize: '11px',
  lineHeight: '14px',
  textShadow: '0px 1px 2px rgba(0, 0, 0, 0.04)'
}))

export const SeenFor = styledComponent(Typography)(() => ({
  color: '#4C5870',
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: '14px',
  whiteSpace: 'nowrap'
}))

export const Tag = styledComponent(Box)(() => ({
  backgroundColor: '#EAEEFC',
  borderRadius: '16px',
  lineHeight: '20px',
  fontSize: '13px',
  fontWeight: 500,
  padding: '2px 12px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '#1A3586'
}))

export const RatingWrapper = styledComponent(Box)(() => ({
  display: 'flex',
  alignItems: 'start',
  gap: '8px'
}))

export const CustomLink = styledComponent(Link)(() => ({
  textDecoration: 'none',
  fontWeight: 500,
  lineHeight: '22px',
  color: '#051851',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '220px',
  display: 'block'
}))
